import React from "react";
import FeatureCard from "../../components/featurecard/FeatureCard";
import stylestext from "../../components/servicecard/Servicecard.module.css";
import styles from "./Products.module.css";
import SeoPage from "../../components/seo/SeoPage";
import holybharat from "../../assets/images/holybharat.jpg";
import marketplace from "../../assets/images/marketplace.jpg";
import ifillip from "../../assets/images/ifillip.jpg";
import mazecrm from "../../assets/images/mazecrm.jpg";

const Products = () => {
  // Feature card data
  const featureCards = [
    {
      title: "IFILLIP",
      heading: "Intelligent Schooling, Redefined",

      para1:
        "IoT-powered operations for modern educational institutions iFillip is a comprehensive, cloud-based school management platform designed to streamline academic and administrative processes. A key differentiator is its IoT-enabled attendance management system, enabling accurate, real-time tracking and seamless integration with school workflows. Built to simplify complexity and improve transparency, iFillip empowers schools to manage operations efficiently through a single, scalable digital platform.",
      // para2:
      //   "Designed as an omni-channel solution, iFillip simplifies routine operations  - like attendance, fee management, timetabling, and reporting  - allowing teachers and administrators to focus on what truly matters: student engagement and growth.",
      // para3:
      //   "But that’s not all! It also features a robust built-in online classroom module, enabling virtual learning with tools like live classes, assignments, discussions, and more. With a multi-layered architecture, user-friendly design, and strong data security, iFillip is the go-to platform for modern educational institutions.",
      media: ifillip,
      buttonText: "Explore iFillip",
      buttonLink: "https://ifillip.com/",
      newTab: true,
    },
    {
      title: "HOLYBHARAT",
      heading: "Nourish Your Soul",

      para1:
        "India’s digital repository of temples, traditions, and sacred spaces Holy Bharat is a thoughtfully curated digital platform that brings India’s spiritual heritage closer to devotees and seekers. Designed as a non-commercial discovery and information repository, it enables users to explore temples, understand traditions, and learn about sacred spaces across the country. Available on iOS and Android, Holy Bharat offers a calm, intuitive experience that supports spiritual exploration, reflection, and meaningful connection.",
      // para2:
      //   "Whether you're planning a visit or seeking spiritual knowledge, HolyBharat offers accurate and current information in a user-friendly format - bringing you closer to the divine, wherever you are.",
      // para3: "Explore. Connect. Nourish your soul.",
      media: holybharat,
      // buttonText: "Experience Holy Bharat",
      // buttonText: "Request a Demo",
      // buttonLink: "/lets-talk",
      newTab: false,
    },
    {
      title: "MAZE",
      heading: "One Platform. Total Control.",

      para1:
        "Unified CRM for sales, staffing, and support operations Maze CRM is a robust, customizable CRM platform built on open-source foundations and tailored to enterprise and services-led businesses. In addition to core CRM and role-based access control (RBAC), it includes integrated timesheet management, recruitment management, and support ticket management modules. With configurable workflows and automation, Maze CRM delivers end-to-end visibility, accountability, and operational control across teams.",
      // para2:
      //   "Shop or sell from the comfort of your home, 24/7. With secure transactions, easy navigation, and real-time updates, Bharat Marketplace is your digital partner for all things retail.",
      // para3:
      //   "Designed for performance and scalability, BharatKart empowers brands to sell smarter, reach wider audiences, and deliver seamless shopping experiences.",
      media: mazecrm,
      // buttonText: "Talk to Us About Maze CRM",
      buttonText: "Request a Demo",
      buttonLink: "/lets-talk",
      newTab: false,
    },
    {
      title: "BHARAT MARKETPLACE ",
      heading: "Built to Sell. Designed to Scale.",

      para1:
        "A complete digital commerce engine for modern businesses This is a full-featured eCommerce platform with web and mobile app support, offering everything needed to run a modern digital marketplace product catalogues, payments, logistics, order management, and customer engagement. Designed for performance, flexibility, and scalability, the platform enables businesses to launch quickly, run seamlessly, and grow confidently in an evolving digital economy.",
      // para2:
      //   "Whether you’re scaling a startup or managing enterprise operations, Maze helps you automate workflows, improve customer engagement, and boost productivity.",
      // para3:
      //   "It fosters economic growth and supports local businesses while connecting buyers with unique products and services.",
      media: marketplace,
      // buttonText: "Build Your Digital Marketplace",
      buttonText: "Request a Demo",
      buttonLink: "/lets-talk",
      newTab: false,
    },
  ];

  return (
    <>
      <SeoPage
        title="iFillip | Holy Bharat | Bharat Marketplace - our exclusive products"
        description="Our exclusive application iFillip, Holy bharat, Bharat marketpalce designed to empower and server the better experience to users"
      />
      <section className={`container-fluid ${styles.customPadding}`}>
        {/* Heading Section */}
        <div className={`${styles.nameContainer} text-center mb-5`}>
          <h5
            className={`main_heading custom-space ${stylestext.service_heading}`}
          >
            Powering Digital Innovation Across Industries
          </h5>
          <p className={`main_subheading ${stylestext.service_subheading} p-0`}>
            Explore our suite of purpose-built digital products designed to
            solve real business challenges. From intelligent school management
            and CRM platforms to digital marketplaces and spiritual discovery
            apps, each solution is engineered for scalability, efficiency, and
            measurable impact. Discover how Bharat Clouds transforms ideas into
            powerful, future-ready platforms.
          </p>
        </div>

        {/* Feature Cards Section */}
        <div className="d-flex flex-column">
          {featureCards.map((card, index) => (
            <FeatureCard
              key={index}
              heading={card.heading} // pass heading here
              title={card.title}
              para1={card.para1}
              para2={card.para2}
              para3={card.para3}
              media={card.media}
              reverse={index % 2 !== 0}
              darkBackground={index % 2 !== 0}
              isOdd={index % 2 === 0} // true for 0, 2,... => odd-styled cards
              buttonText={card.buttonText}
              buttonLink={card.buttonLink}
              newTab={card.newTab}
            />
          ))}
        </div>
      </section>
    </>
  );
};

export default Products;
